
import * as echarts from 'echarts';
import common from "@/util/common";
import {defineComponent, toRefs, reactive, watch, onMounted, ref, nextTick} from "vue";
 interface State {
        chart:  any;
        indicators: object[];
        radarData: number[];

    }
export default defineComponent({
    name: 'BatteryRadar',
    props: {
        renderData: {
            type: Object,
            default: () => {
                return {}
            }
        },
    },
    setup(props: any) {
        function getData(list, code, key='value', type='') {
            return common.getDataByCode(list,  code, key, type)
        }
        function transNum(num) {
            let res = 0;
            switch(num) {
                case '0':
                    res = 5;
                    break;
                case '1':
                    res = 4.5;
                    break;
                case '2':
                    res = 4;
                    break;
                case '3':
                    res = 3;
                    break;
            }
            return res;
        }
        let cellUnder = getData(props.renderData, 'cellUnderVoltage', 'items'); // 单体欠压
        let cellOver = getData(props.renderData, 'cellOverVoltage', 'items'); // 单体过压
        let difference = getData(props.renderData, 'voltageDifference', 'items');  // 电压差异
        let overTemperature = getData(props.renderData, 'batteryOverTemperature', 'items');    // 电池过温
        let temperatureDifference = getData(props.renderData, 'temperatureDifference', 'items');   // 温度差异
        const skills = ref([
          { name: 'Пониженное напряжение ячейки', value: transNum(getData(cellUnder, 'cellUnderVoltage')) },
          { name: 'Разница\nтемпературы', value: transNum(getData(temperatureDifference, 'temperatureDifference')) },
          { name: 'Перегрев\nаккумулятора', value: transNum(getData(overTemperature, 'batteryOverTemperature')) },
          { name: 'Разница\nнапряжения', value: transNum(getData(difference, 'voltageDifference')) },
          { name: 'Перенапряжение\nячейки', value: transNum(getData(cellOver, 'cellOverVoltage')) },
        ]);
        console.log('单体过压', getData(cellUnder, "cellUnderVoltage"));
        const showComparison = ref(false);
        let chartInstance;
        const initChart = () => {
          const chartDom = document.getElementById('radar-chart');
          chartInstance = echarts.init(chartDom);
          console.log('initChart');
          
          const option = {
            // tooltip: {
            //   trigger: 'item'
            // },
            grid: {
                left: '0',
                top: '0',
                right: '0',
                bottom: '0',
            },
            radar: {
              indicator: skills.value.map(item => ({
                name: item.name,
                max: 5
              })),
              shape: 'polygon',
              splitNumber: 4,
              radius: 70,
              center:['50%', '50%'],
              axisName: {
                color: '#585D6A',
                // borderRadius: 3,
                fontSize: 11,
                // padding: -5
              },
              splitLine: {
                lineStyle: {
                  color: '#0CDCAD33'
                }
              },
              splitArea: {
                areaStyle: {
                  color: ['#0CDCAD1A', '#0CDCAD1A'],
                  shadowColor: 'rgba(0, 0, 0, 0.2)',
                  shadowBlur: 10
                }
              },
              axisLine: {
                lineStyle: {
                  color: '#0CDCAD33'
                }
              }
            },
            series: [
              {
                name: '',
                type: 'radar',
                data: [
                  {
                    value: skills.value.map(item => item.value),
                    name: '',
                    areaStyle: {
                      color: '#0BD4A766'
                    },
                    lineStyle: {
                      color: '#0BD4A7',
                      width: 2
                    },
                    itemStyle: {
                        color: '#0BD4A7',
                        borderColor: '#ffffff',
                        borderWidth: 2
                    },
                  }
                ]
              }
            ]
          };
          
          chartInstance.setOption(option);
          
          // 响应窗口大小变化
          window.addEventListener('resize', () => {
            chartInstance.resize();
          });
        };
        
        
        
        const toggleComparison = () => {
          showComparison.value = !showComparison.value;
        };
        
        onMounted(() => {
          nextTick(() => {
            initChart();
          });
        });
        
        watch([skills, showComparison], () => {
          if (chartInstance) {
            initChart();
          }
        }, { deep: true });
        
        return {
            skills,
            showComparison,
            getData,
            toggleComparison
        };
      }
   
});
